import { render, staticRenderFns } from "./AttributesForBookingCell.vue?vue&type=template&id=31256b34&scoped=true&"
import script from "./AttributesForBookingCell.vue?vue&type=script&lang=js&"
export * from "./AttributesForBookingCell.vue?vue&type=script&lang=js&"
import style0 from "./AttributesForBookingCell.vue?vue&type=style&index=0&id=31256b34&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31256b34",
  null
  
)

export default component.exports